import moment from 'moment';

moment.locale('es');
moment.defaultFormat = 'DD/MM/YYYY hh:mm A';

export default function (value: string){
    if(!value) return '-';
    return moment(value).format('DD/MM/YYYY');
}